import { FormAction } from '@anytag/shared-types';
import { useQueryHelper } from '@anytag/shared-hooks';
import {
  namedOperations,
  ProposalJobDescriptionBreakDownMode,
  PackageProposalSocialAcccountBudgetInput,
  useUpdatePackageProposalInfluencersBudgetMutation,
  useUpdatePackageProposalSocialAccountsBudgetMutation
} from '@anytag/graphql';
import { RowPackageData } from '../PackageContentList/types';
import { ProposeInfluencersFormValues } from '../../../Influencers';

interface SaveProposalProps {
  jdMode?: ProposalJobDescriptionBreakDownMode;
  packageId: number;
}
export const useUpdatePackageProposal = ({ jdMode, packageId }: SaveProposalProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { callUpdatePackageProposalInfluencersBudget } = useUpdatePackageProposalInfluencersBudgetMutation({
    refetchQueries: [namedOperations.Query.PackageProposal]
  });
  const { callUpdatePackageProposalSocialAccountsBudget } = useUpdatePackageProposalSocialAccountsBudgetMutation({
    refetchQueries: [namedOperations.Query.PackageProposal]
  });

  const handleSaveProposal =
    (tableData: RowPackageData[]): FormAction<ProposeInfluencersFormValues>['onSubmit'] =>
    async (values, { formState, reset }) => {
      if (!formState.isDirty) {
        return;
      }

      try {
        if (jdMode === ProposalJobDescriptionBreakDownMode.INFLUENCER_BREAKDOWN) {
          await callUpdatePackageProposalInfluencersBudget({
            variables: {
              input: {
                packageId,
                influencers:
                  tableData?.map(({ influencer }, index) => ({
                    influencerId: influencer.id,
                    profit: Number(values[`${index}-profit`]),
                    budget: Number(values[`${index}-budget`]),
                    influencerCost: Number(values[`${index}-influencerCost`])
                  })) || []
              }
            }
          });
        } else {
          await callUpdatePackageProposalSocialAccountsBudget({
            variables: {
              input: {
                packageId,
                socialAccounts: tableData.reduce<PackageProposalSocialAcccountBudgetInput[]>(
                  (results, { influencer, socialAccount }, index) => {
                    if (socialAccount) {
                      return [
                        ...results,
                        {
                          influencerId: influencer.id,
                          socialAccountId: socialAccount.id,
                          socialAccountType: socialAccount.socialMedia,
                          profit: Number(values[`${index}-profit`]),
                          budget: Number(values[`${index}-budget`]),
                          influencerCost: Number(values[`${index}-influencerCost`])
                        }
                      ];
                    }

                    return results;
                  },
                  []
                )
              }
            }
          });
        }

        enqueueSnackbar(t('succeededUpdateWhitelist'), { variant: 'success' });
        reset(values);
      } catch (error) {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      }
    };

  return { handleSaveProposal };
};
